export const stringMaxLength = (length) => (value) => {
  if (value?.length > length) {
    return `Field cannot be longer than ${length} characters`
  }
}

export const stringMinLength = (length) => (value) => {
  if (value?.length < length) {
    return `Field cannot be shorter than ${length} characters`
  }
}
